import { render, staticRenderFns } from "./EmailDisconnectedDialog.vue?vue&type=template&id=c7405796"
import script from "./EmailDisconnectedDialog.vue?vue&type=script&lang=js"
export * from "./EmailDisconnectedDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7405796')) {
      api.createRecord('c7405796', component.options)
    } else {
      api.reload('c7405796', component.options)
    }
    module.hot.accept("./EmailDisconnectedDialog.vue?vue&type=template&id=c7405796", function () {
      api.rerender('c7405796', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/conversations/chat-box/EmailDisconnectedDialog.vue"
export default component.exports